import extensibilityState from './store';
import { ExtensibilityModeEnum } from 'owa-addins-types';

export function getSurfaceNewAddinId(extMode: ExtensibilityModeEnum): string {
    switch (extMode) {
        case ExtensibilityModeEnum.MessageRead:
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (10,13): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            return extensibilityState.mailReadSurfaceNewAddinId;
        case ExtensibilityModeEnum.MessageCompose:
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (15,13): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            return extensibilityState.mailComposeSurfaceNewAddinId;
        case ExtensibilityModeEnum.AppointmentOrganizer:
        case ExtensibilityModeEnum.AppointmentAttendee:
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (21,13): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            return extensibilityState.calendarSurfaceNewAddinId;
        default:
            return '';
    }
}
